import React, {useState, useEffect, useMemo, useReducer} from 'react';
import styled from 'styled-components';
import {color} from '@ey/styled-theme';
import Tabs from '../../Common/TabBar/TabBar';
import Item from './Item';
import DataReducer from './DataReducer';
import MotifSearch from '../../Common/Search/MotifSearch';
import {labels, currentResource} from '../../../util/utils';
import utilityfunctions from '../../../util/utilityfunctions';
import Dropdown from '@ey/motif-react-wrapper/Dropdown';
import Select from '../../CoreWrappers/Select';
import MotifDropdownItem from '@ey/motif-react-wrapper/DropdownItem';
import MotifIconButton from '@ey/motif-react-wrapper/IconButton';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {hardwareIcKeyboardArrowDown24px, contentIcAddCircle24px} from '@ey/motif-react-wrapper/assets/icons';
import PlaceHolder from '../Placeholder/Placeholder';
import Loader from '../../Common/LoadingIndicator';
import AddNewGroupModal from '../../Pages/CreateProjectClassic/AddNewGroup/AddNewGroupModal';
import MotifToggleSwitch from '@ey/motif-react-wrapper/ToggleSwitch';
import {isAllItemSelected, isAllItemUnSelected} from './SelectionHelper';
import Checkbox from '../../CoreWrappers/Checkbox';

function DataContainer(props) {
	const {
		isServerSide,
		loadData,
		showDetailsToggleSwitch,
		showDetailsHandler,
		tabSwitchHandler,
		disableCheckbox,
		setDisableCheckbox
	} = props;
	const [isFetching, setIsFetching] = useState(false);
	const [showDetailsToggle, setShowDetailsToggle] = useState(false);

	const [isModalVisible, setModalVisibility] = useState(false);

	// Below state to keep track if all items are selected.
	const [isSelectionInProgress, setIsSelectionInProgress] = useState(null);

	// Maintain list of connected ids of item. It will reduce the effort to find ids each time.
	const [connectedData, setConnectedData] = useState([]);

	const toggleModalVisibility = () => {
		setModalVisibility(false);
	};

	const handleToggle = (value) => {
		setModalVisibility(value);
	};

	const showDetailsToggleHandler = () => {
		showDetailsHandler(!showDetailsToggle, dataContainerState.activeTab);
		setShowDetailsToggle(!showDetailsToggle);
	};

	const {configuration, selectedItems, setSelectedItems} = props;
	const [dataContainerState, dispatch] = useReducer(DataReducer, {
		activeTab: '1',
		tabs: configuration.tabsParameters && configuration.tabsParameters.tabs ? configuration.tabsParameters.tabs : [],
		dataItems: props.data,
		dataGroupedBy: currentResource.engagementsViewBy[0],
		searchAttributes: configuration.searchAttributes,
		searchValue: '',
		allData: props.data,
		viewByVisible: false,
		showViewOption: configuration.viewByOption,
		viewConnectedItemBy: configuration.viewConnectedItemBy
	});

	const validateData = () => {
		if (!props.data) {
			return false;
		}

		if (props.data === Object) {
			return Object.keys(props.data).length !== 0;
		}

		return true;
	};

	// below selection will check if all items are selected or unselected when user click on select all
	// while selection is in progress, show loading indicator with flag isSelectionInProgress
	useEffect(() => {
		if (isSelectionInProgress) {
			// having timeout of 0 ms ensure loading indicator starts appearning on UI immediately and user gets good user expereience.
			setTimeout(() => {
				let availableItems = getListFilterData(dataContainerState.dataItems, dataContainerState.activeTab);
				if (selectedItems.length === 0 || availableItems.length !== selectedItems.length) {
					let selectedIds = [];
					availableItems.forEach((item) => selectedIds.push(getObjectId(item, configuration.idAttributeName)));
					setSelectedItems(selectedIds);
					isAllItemSelected(availableItems.length, setIsSelectionInProgress);
				} else {
					setSelectedItems([]);
					isAllItemUnSelected(setIsSelectionInProgress);
				}
			}, 0);
		}
	}, [isSelectionInProgress]);

	useEffect(() => {
		if (validateData()) {
			// No need to refresh available if user is on connected tab
			if (props.isStep4 == true && dataContainerState.activeTab == 2) {
				return;
			}
			let dataCopy = _.cloneDeep(props.data);
			let data = utilityfunctions.sortListData(dataCopy, configuration.sortAttribute);
			let availableData = getFilteredData(dataContainerState.searchValue, data);
			!_.isEmpty(availableData) &&
				dispatch({
					type: 'Set-Search-Value',
					allData: data,
					dataItems: availableData.data,
					updatedTabs: [
						{
							id: '1',
							count: availableData.count
						},
						{
							id: '2',
							count: props.connectedData && props.connectedData.length
						}
					]
				});

			_.isEmpty(availableData) &&
				dispatch({
					type: 'Update-Tabs-Value',
					updatedTabs: [
						{
							id: '1',
							count: availableData.length
						},
						{
							id: '2',
							count: props.connectedData.length
						}
					]
				});
		}
	}, [props.data]);

	useEffect(() => {
		if (props.connectedData && !_.isEmpty(props.data)) {
			let connectedItems = [];
			props.connectedData.forEach((item) => {
				connectedItems.push(item[configuration.idAttributeName]);
			});
			setConnectedData(connectedItems);

			let availableData = props.filterAvailableData
				? props.data.filter((item) => {
						return !connectedItems.includes(getObjectId(item, configuration.idAttributeName));
				  })
				: props.data;

			let connectedData = getFilteredData(dataContainerState.searchValue, props.connectedData, {
				tabValue: 2,
				filterData: false
			});

			// Gets the filtered data count if search input is there
			if (dataContainerState.searchValue !== '') {
				if (dataContainerState.activeTab == 1) {
					availableData = utilityfunctions.getFilterdData(
						dataContainerState.searchValue,
						availableData,
						dataContainerState.searchAttributes.searchKeys
					);
				} else {
					connectedData = getFilteredData(dataContainerState.searchValue, props.connectedData, {
						tabValue: 2,
						filterData: true
					});
				}
			}

			let availableDataLength = !_.isEmpty(availableData) ? availableData.length : 0;
			availableData = utilityfunctions.sortListData(availableData, configuration.sortAttribute);
			let availableDataRendered = availableData;
			let option = dataContainerState.dataGroupedBy;
			if (option && option.id != 0) {
				availableDataRendered = utilityfunctions.getGroupedData(
					availableData,
					option.groupAttributeName,
					configuration.sortAttribute
				);
			}
			!_.isEmpty(availableData) &&
				dispatch({
					type: 'Set-Search-Value',
					allData: props.data,
					dataItems: dataContainerState.activeTab == 1 ? availableDataRendered : connectedData.data,
					updatedTabs: [
						{
							id: '1',
							count: availableDataLength
						},
						{
							id: '2',
							count: connectedData.count
						}
					]
				});

			_.isEmpty(availableData) &&
				dispatch({
					type: 'Update-Tabs-Value',
					updatedTabs: [
						{
							id: '1',
							count: availableDataLength
						},
						{
							id: '2',
							count: connectedData.count
						}
					]
				});
		}
	}, [props.connectedData]);

	useEffect(() => {
		if (isServerSide) {
			setIsFetching(true);
			let promise = props.loadData();
			promise &&
				promise.then(function() {
					console.log('test');
					setIsFetching(false);
				});
		}
		return () => {};
	}, []);

	const [viewByOptionSelected, setViewByOptionSelected] = useState(
		currentResource.engagementsViewBy.find(function(item) {
			return item.value;
		})
	);

	const [viewByLabelSelected, setViewByLabelSelected] = useState(
		currentResource.engagementsViewBy.find(function(item) {
			return item.label;
		})
	);

	const handleViewByToggle = () => {
		dispatch({type: 'Set-View-By-Visible', viewByVisible: !dataContainerState.viewByVisible});
	};

	const setClickOutsideViewBy = () => {
		if (dataContainerState.viewByVisible) {
			dispatch({type: 'Set-View-By-Visible', viewByVisible: false});
		}
	};
	const viewById = 'dropdown-1';
	const triggerViewById = 'dropdown-trigger-1';

	const getListContainerClassName = () => {
		if (props && props.listContainerClass) {
			return props.listContainerClass;
		}

		return 'list-container-wrapper';
	};

	const getListItemsContainerClassName = (param, attribute) => {
		if (param && param[attribute]) {
			return param[attribute];
		}

		return 'listitems-container';
	};

	const getTabsCount = () => {
		let updatedTabs = [
			{id: '1', count: props.filterAvailableData ? props.data.length - props.connectedData.length : props.data.length},
			{id: '2', count: props.connectedData.length}
		];
		return updatedTabs;
	};

	const onTabChange = (tabName, label) => {
		let currentTabAllData;
		tabSwitchHandler && tabSwitchHandler(tabName);
		if (tabName == '1') {
			// Todo - Need to check on removing clone deep.
			let dataCopy = _.cloneDeep(props.data);
			currentTabAllData = utilityfunctions.sortListData(dataCopy, configuration.sortAttribute);
		} else {
			currentTabAllData = props.connectedData;
		}

		let allData = getListFilterData(currentTabAllData, tabName);
		dispatch({
			type: 'Active-Tab-Change',
			activeTab: tabName,
			showViewOption: configuration.showViewOptions && configuration.showViewOptions(tabName),
			allData: allData,
			dataItems:
				tabName == '1'
					? viewByOptionSelected.id === 0
						? allData
						: utilityfunctions.getGroupedData(
								allData,
								viewByOptionSelected.groupAttributeName,
								configuration.sortAttribute
						  )
					: utilityfunctions.getGroupedData(
							allData,
							dataContainerState.viewConnectedItemBy.groupAttributeName,
							configuration.sortAttribute
					  ),
			dataGroupedBy:
				tabName == '1'
					? currentResource.engagementsViewBy[viewByOptionSelected.id]
					: dataContainerState.viewConnectedItemBy,
			searchValue: '',
			updatedTabs: getTabsCount()
		});
	};

	const showDetailsText = (
		<span className="show-details-text ellipsis" title={labels.showDetails}>
			{labels.showDetails}
		</span>
	);

	const tabComponent = (
		<section className="tabs-wrap">
			<Tabs
				badge
				activeTab={dataContainerState.activeTab}
				tabs={dataContainerState.tabs}
				styleName={'tabbar-tabs'}
				onTabChange={(number, label) => onTabChange(number, label)}
			/>
			{showDetailsToggleSwitch && (
				<MotifToggleSwitch
					id={`toggle-${'show-details'}`}
					className={showDetailsToggle ? 'show-details-toggleon ellipsis' : 'show-details-toggleoff ellipsis'}
					checked={showDetailsToggle}
					// disabled={isApiInProgress}
					onChange={() => showDetailsToggleHandler()}
					offLabel={showDetailsText}
					onLabel={''}
					title={labels.showDetails}
				/>
			)}
		</section>
	);

	const filterOnParentId = (item) => {
		if (configuration.parentIdAttributeName) {
			let exist = _.some(props.connectedData, (row) => {
				let valueObjectConnected = getObjectId(item, configuration.parentIdAttributeName);
				let valueObject = getObjectId(row, configuration.parentIdAttributeName);

				let valueChildObjectConnected = getObjectId(item, configuration.idAttributeName);
				let valueChildObject = getObjectId(row, configuration.idAttributeName);

				let dataExist = valueObjectConnected == valueObject && valueChildObjectConnected == valueChildObject;
				if (dataExist) {
					return dataExist;
				}
			});

			return exist;
		}

		return true;
	};

	const getListFilterData = (data, tab, inputParam) => {
		let activeTab = tab ? tab : dataContainerState.activeTab;
		if (activeTab == 1) {
			if (inputParam && inputParam.calculateLength) {
				if (Array.isArray(data)) {
					return data.length;
				} else {
					let totalLength = 0;
					Object.keys(data).map((key, index) => {
						let groupedData = dataContainerState.dataItems[key];
						let newData = groupedData.filter((item) => {
							return !connectedData.includes(getObjectId(item, configuration.idAttributeName));
						});
						totalLength = totalLength + newData.length;
					});
					return totalLength;
				}
			} else {
				if (Array.isArray(data)) {
					return props.filterAvailableData
						? data.filter((item) => {
								return !connectedData.includes(getObjectId(item, configuration.idAttributeName));
						  })
						: data;
				} else {
					let newDataFiltered = [];
					Object.keys(data).map((key, index) => {
						let groupedData = dataContainerState.dataItems[key];
						let newData = groupedData.filter((item) => {
							return !connectedData.includes(getObjectId(item, configuration.idAttributeName));
						});
						newDataFiltered = [...newDataFiltered, ...newData];
					});

					return newDataFiltered;
				}
			}
		} else {
			let filterData = data.filter((item) => {
				let filter = false;
				if (configuration.parentIdAttributeName) {
					filter = filterOnParentId(item);
				} else {
					if (inputParam && inputParam.filterData) {
						filter = connectedData.includes(getObjectId(item, configuration.idAttributeName));
					} else {
						return true;
					}
				}

				return filter;
			});

			return filterData;
		}
	};

	const getRenderedComponent = (isGrouped, groupLabel, groupRows, index) => {
		let item = {...configuration, activeTab: dataContainerState.activeTab};
		let placeholderMessage = '';
		if (!_.isEmpty(dataContainerState.searchValue) && dataContainerState.dataItems.length == 0) {
			return labels.noResultsFound;
		}

		if (dataContainerState.dataItems.length == 0) {
			return labels.placeholderStep3NoEngagementMessage;
		}
		if (isGrouped && (_.isUndefined(groupLabel) || groupLabel == 'null')) {
			groupLabel =
				viewByOptionSelected.id == 1
					? labels.countryNotAvailable
					: viewByOptionSelected.id == 1 && labels.regionNotAvailable;
		}
		if (!isGrouped) {
			let filteredData = getListFilterData(dataContainerState.dataItems, dataContainerState.activeTab);
			return (
				dataContainerState.dataItems &&
				dataContainerState.dataItems.length >= 0 && (
					<Item
						groupConfig={item}
						listData={filteredData}
						isGrouped={false}
						placeholderMessage={placeholderMessage}
						idAttributeName={configuration.idAttributeName}
					/>
				)
			);
		} else {
			let filteredData = getListFilterData(groupRows, dataContainerState.activeTab);
			console.log(filteredData);
			return (
				_.size(filteredData) > 0 && (
					<Item
						groupHeaderLabel={groupLabel}
						groupConfig={item}
						listData={filteredData}
						isGrouped={isGrouped}
						index={index}
						key={'Group_Item_' + groupLabel}
						idAttributeName={configuration.idAttributeName}
					></Item>
				)
			);
		}
	};

	// If input data is changed (i.e. props.data) and searched value is there, filter the data accordingly.

	const getFilteredData = (searchValue, data, inputParam) => {
		let filterData = getListFilterData(
			data,
			inputParam && inputParam.tabValue ? inputParam.tabValue : dataContainerState.activeTab
		);
		let filter = true;
		if (inputParam && inputParam.filterData === false) {
			filter = false;
		}
		if (searchValue != '' && filter) {
			filterData = utilityfunctions.getFilterdData(
				searchValue,
				filterData,
				dataContainerState.searchAttributes.searchKeys
			);
		}

		let count = filterData.length;

		if (
			dataContainerState.dataGroupedBy.id != 0 &&
			dataContainerState.dataGroupedBy &&
			dataContainerState.dataGroupedBy.groupAttributeName
		) {
			filterData = utilityfunctions.getGroupedData(
				filterData,
				dataContainerState.dataGroupedBy.groupAttributeName,
				configuration.sortAttributeName
			);
		}

		return {
			count: count,
			data: filterData
		};
	};

	const handlerOnSearch = (value) => {
		let data = dataContainerState.activeTab == 1 ? dataContainerState.allData : props.connectedData;
		let filterData = getFilteredData(value, data);

		let count = filterData.count;

		dispatch({
			type: 'Set-Search-Value',
			searchValue: value,
			dataItems: filterData.data,
			updatedTabs: [
				{
					id: dataContainerState.activeTab,
					count: count
				}
			]
		});
	};

	// On clear search, remove search text and reset the list.
	const handlerOnClearSearch = () => {
		let data = dataContainerState.activeTab == 1 ? dataContainerState.allData : props.connectedData;
		let filteredData = getListFilterData(data, dataContainerState.activeTab);
		let availableData = getFilteredData('', filteredData);
		dispatch({
			type: 'Set-Search-Value',
			searchValue: '',
			dataItems: availableData.data,
			updatedTabs: [
				{
					id: dataContainerState.activeTab,
					count: filteredData.length
				}
			]
		});
	};

	const handleronViewChange = (id) => {
		const option = configuration.viewByOption.options.find((e) => e.id === id);
		setViewByOptionSelected(option);
		setViewByLabelSelected(option);
		let data = dataContainerState.allData;
		data = getListFilterData(data, dataContainerState.activeTab);
		let count = data.length;
		if (option.id != 0) {
			data = utilityfunctions.getGroupedData(data, option.groupAttributeName, configuration.sortAttribute);
		}
		dispatch({
			type: 'Set-View-Type',
			searchValue: '',
			dataGroupedBy: option,
			dataItems: data,
			viewByVisible: false,
			updatedTabs: [
				{
					id: dataContainerState.activeTab,
					count: count
				}
			]
		});
	};

	// If any item is already selected, remove all selection. Else selected all the items
	const selectAllItems = (e) => {
		setIsSelectionInProgress(true);
	};

	const getPlaceHolderMessage = () => {
		let message = undefined;
		if (!dataContainerState.dataItems) {
			return message;
		}

		const selectTab = dataContainerState.tabs.find((tab) => {
			return tab.id == dataContainerState.activeTab;
		});
		if (
			!_.isEmpty(dataContainerState.searchValue) &&
			(Object.keys(dataContainerState.dataItems).length == 0 || (selectTab && selectTab.value == 0))
		) {
			message = labels.noResultsFound;
		} else if (
			dataContainerState.activeTab === '1' &&
			_.size(props.data) !== 0 &&
			_.size(props.data) === _.size(props.connectedData) &&
			props.allItemConnectedMessgae
		) {
			message = props.allItemConnectedMessgae;
		} else if (_.size(Object.keys(dataContainerState.dataItems)) <= 0) {
			message =
				dataContainerState.activeTab == '1'
					? props.placeholderMessage
					: props.placeholderConnectedTabMessage
					? props.placeholderConnectedTabMessage
					: labels.placeholderStep3NoConnectedEngagementMessage;
		}

		// If user is on tab 2 and no data in connected engagements, show appropraite messgae. It is possible that connected engagements
		// is empty but dataContainerState.dataItems has items as dataContainerState.dataItems gets updated only on tab change
		else if (_.size(connectedData) == 0 && dataContainerState.activeTab == '2') {
			message = props.placeholderConnectedTabMessage
				? props.placeholderConnectedTabMessage
				: labels.placeholderStep3NoConnectedEngagementMessage;
		}

		return message;
	};

	let placeholderMessage = getPlaceHolderMessage();

	const getObjectId = (item, idAttributeName) => {
		return item[idAttributeName];
	};

	const getPlaceholerTemplate = (message) => {
		if (configuration.getPlaceholderFormat && dataContainerState.activeTab == '1' && !dataContainerState.searchValue) {
			// render for step 4 and available tab
			return configuration.getPlaceholderFormat(message);
		}
		return <PlaceHolder placeholderMessage={placeholderMessage}></PlaceHolder>;
	};

	const renderSelect = () => {
		const props = {
			label: labels.viewLabel,
			options: configuration.viewByOption.options,
			value: viewByOptionSelected.id ?? configuration.viewByOption.options[0].id,
			onChange: handleronViewChange
		};

		return <Select {...props} />;
	};

	return (
		<StyledListContainer className={getListContainerClassName()}>
			<section
				className={`list-container  ${
					configuration.searchAttributes && configuration.searchAttributes.allowSearch ? '' : 'step4-nosearch'
				}`}
			>
				{!dataContainerState.dataItems ? (
					<Loader view="inlineView" show={!dataContainerState.dataItems && isFetching} />
				) : (
					<section className={`${getListItemsContainerClassName(props, 'listItemsContainerClass')} items-wrap`}>
						<section className={`filter-search-wrapper`}>
							<section className="filter-search-wrap">
								{configuration.searchAttributes && configuration.searchAttributes.allowSearch && (
									<MotifSearch
										styleName="engagement-search"
										placeholder={props.searchPlaceholder ? props.searchPlaceholder : ''}
										value={dataContainerState.searchValue}
										searchHoverText={labels.search}
										onChange={handlerOnSearch}
										onClear={handlerOnClearSearch}
									/>
								)}
							</section>
							{dataContainerState.showViewOption && <section className={`engagementview-by`}>{renderSelect()}</section>}
						</section>
						{isSelectionInProgress && <Loader view="inlineView" />}
						<section
							className={`available-eng-container ${
								dataContainerState.activeTab == '1' ? 'available-content' : 'connected-content'
							}`}
						>
							{tabComponent}
							{dataContainerState.activeTab == '1' && (
								<section className="add-new-eng">
									<section className="checkbox-wrap">
										<Checkbox
											id={'SelectAllItems'}
											label={`${selectedItems.length} ${labels.selectedLabel}`}
											name="Checkbox"
											noOfLines={1}
											styleName="selected-checkbox"
											ellipse
											checked={selectedItems.length > 0}
											onChange={(e) => selectAllItems(e)}
											className={
												selectedItems.length != 0 &&
												selectedItems.length <
													getListFilterData(dataContainerState.dataItems, dataContainerState.activeTab, {
														calculateLength: true
													})
													? 'partialChecked'
													: ''
											}
											disabled={placeholderMessage ? true : false}
										/>
									</section>
									{props.isStep4 && (
										<section
											className="icon-add-eng-wrap"
											onClick={() => {
												handleToggle(true);
											}}
										>
											<MotifIcon title={labels.addAGroup} src={contentIcAddCircle24px} />
											<span title={labels.addAGroup} className="add-new-eng-text">
												{labels.addAGroup}
											</span>
										</section>
									)}
									{isModalVisible && (
										<AddNewGroupModal
											showModal={isModalVisible}
											toggleModalVisibility={handleToggle}
											accessgroups={props.data}
										/>
									)}
								</section>
							)}

							<section
								className={`${'list-items-container'} ${
									dataContainerState.dataGroupedBy.id != 0 ? 'grouped-cotainer' : 'all-container'
								}`}
							>
								<section className={`list-items-body customScrollbar ${placeholderMessage ? 'no-results' : ''}`}>
									{placeholderMessage
										? getPlaceholerTemplate()
										: dataContainerState.dataGroupedBy &&
										  dataContainerState.dataGroupedBy.id != 0 &&
										  Object.keys(dataContainerState.dataItems).length > 0
										? Object.keys(dataContainerState.dataItems).map((key, index) => {
												let renderedGroupData = dataContainerState.dataItems[key];
												if (renderedGroupData.find) {
													let searchEngagement =
														dataContainerState.activeTab == '1'
															? renderedGroupData.find((item) => {
																	return !connectedData.includes(getObjectId(item, configuration.idAttributeName));
															  })
															: renderedGroupData.find((item) => {
																	return connectedData.includes(getObjectId(item, configuration.idAttributeName));
															  });
													if (searchEngagement) {
														return getRenderedComponent(true, key, renderedGroupData, index);
													}
												}
										  })
										: getRenderedComponent()}
								</section>
							</section>
						</section>
					</section>
				)}
			</section>
		</StyledListContainer>
	);
}

export default DataContainer;

const StyledListContainer = styled.section`
	display: flex;
	.list-items-container {
		overflow: auto;
		flex: 1;
		background-color: ${(props) => props.theme.color[`grey50`]};

		.list-items-body {
			display: flex;
			width: 100%;
			flex: 1;
			overflow: auto;
			flex-direction: column;
			height: 60rem;
			padding: 1rem;
			border: solid 1px ${(props) => props.theme.color[`grey300`]};
			border-top: 0;

			&.no-results {
				.placeholder-message {
					margin-top: 5rem;
				}
			}
		}
	}
	.list-container {
		width: 100%;
		&.step4-nosearch {
			.filter-search-wrapper {
				display: none;
			}
			.list-items-body {
				height: 62rem;
			}
		}
	}
	.tabs-header {
		display: flex;
		width: 53.5%;
		justify-content: space-between;
	}

	.tabs-wrap {
		display: flex;
		justify-content: space-between;
		& > div:first-child {
			width: 75%;
		} 
	}

	.available-eng-container {
		display: flex;
		flex-direction: column;
		height: 100%;

		.tabbar-tabs {
			padding: 0;
			.motif-tab-bar {
				border: 0;
			}
		}
		
		.add-new-eng {
			font-size: 1.4rem;
			border: solid 1px ${(props) => props.theme.color[`grey300`]};
			border-top: 0;
			padding: 1rem;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.checkbox-wrap {
				display: flex;
				align-items: center;
				width: 15rem;

				.selected-checkbox {
					width: 100%;
				}
			}
			.motif-icon {
				display: flex;
				margin-right: 0.5rem;
				width: 2rem;
				height: 2rem;
				color: ${(props) => props.theme.color[`blue600yellow400`]};
				svg {
					color: var(--ui-background-main);;
				}
			}
			.icon-add-eng-wrap {
				display: flex;
				align-items: center;
				max-width: 18rem;
				cursor: pointer;
				color: ${(props) => props.theme.color[`blue600yellow400`]};
				.add-new-eng-text {
					max-width: 15rem;
					display: inline-block;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}
			.header-check {
				width: 15rem;
			}
		}

		&.connected-content {
			.items-group-header {
				.engagement-wrap {
					border: 0;
					border-left: 0;
					padding: 0 0 0 2rem;
					flex-direction: row;
					justify-content: space-between;
					align-items: center;
					line-height: 1.9rem;
					background-color: transparent;

					.engagement-name-wrap {
						font-size: 1.2rem;
						font-weight: normal;
						.eng-name {
							font-weight: bold;
						}
						.eng-id {
							font-weight: 300;
						}
					}
				}
			}

			.list-items-body {
				padding: 1rem 0;
				.header-badge-wrap {
					padding: 0 2rem;
					.motif-accordion-content-visible {
						padding-bottom: 2rem;
					}
				}
			}
		}
	}

	.filter-search-wrapper {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		gap: var(--spacing-small);
		.engagementview-by {
			display: flex;
			width: 50%;
			justify-content: space-between;
			background: ${(props) => props.theme.color[`grey100`]};
			.motif-dropdown {
				width: 100%;
				.view-text-dropdown {
					display: flex;
					justify-content: space-between;
				}
			}
			.view-text-wrap {
				max-width: 70%;
				display: flex;
				margin-top: -0.3rem;
				flex-direction: column;
				line-height: 1.4rem;
				.view-text {
					font-size: 1rem;
					display: inline-block;
					width: 100%;
					&.label-value {
						font-size: 1.2rem;
					}
				}
			}

			.motif-dropdown-portal {
				display: flex;
				align-items: center;
			}

			.motif-dropdown-portal,
			.motif-dropdown-trigger {
				width: 100%;
				.view-text-dropdown {
					width: 100%;
					display: flex;
					justify-content: space-between;
				}
			}
		}
		.filter-search-wrap {
			display: flex;
			width: 74%;
			.engagement-search {
				width: 95%;
				background-color: ${(props) => props.theme.color[`grey100`]};
				.motif-input {
					font-size: 1.4rem;
					font-weight: 300;
					border-bottom: solid 1px ${(props) => props.theme.color[`grey400`]};
					height: 3.5rem;
					&:hover,
					&:focus:not(:disabled) {
						border-bottom: solid 1px ${(props) => props.theme.color[`grey400`]};
					}
					&::placeholder {
						font-size: 1.4rem;
					}
				}
			}
		}

		.searchIcon {
			display: none;
		}
	}
	.header-badge-wrap {
		&:first-child {
			.GroupHeaderCell {
				margin-top: 0;
			}
		}
	}

	.GroupHeaderCell {
		font-size: 1.6rem;
		font-weight: 300;
		display: inline-block;
		margin-bottom: 1rem;
		margin-top: 1rem;
	}
	.ellipsis {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	.separator {
		margin: 0 0.5rem;
	}
`;
